import { frontendURL } from '../../../helper/URLHelper';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';
import { ONBOARDING_GUIDES_ROUTE } from '../../../helper/onboardingGuide/navigation';
import Index from './Index.vue';

const routerGuard = async (to, from, next) => {
  await subscriptionGuard(to, from, next, store);
};

// The new onboarding list (DRP-174). It lives beside the current
// `onboarding` checklist and is not linked from the sidebar yet: reached by
// URL and from a finished guide's "Mark as complete".

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/onboarding/guides'),
      component: Index,
      name: ONBOARDING_GUIDES_ROUTE,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: routerGuard,
    },
  ],
};
